import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [navLinks, setNavLinks] = useState([]);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    // Parse navigation links from data attribute format
    const linksData = "#summary:Summary,#case-studies:Case Studies,#skills:Skills,#experience:Experience,#honors:Journey & Impact,#about:About me";
    const parsedLinks = linksData.split(',').map(link => {
      const [href, text] = link.split(':');
      return { href: href.trim(), text: text.trim() };
    });
    setNavLinks(parsedLinks);
  }, []);

  const handleNavClick = (section) => {
    // Close mobile menu when a link is clicked
    setIsMobileMenuOpen(false);
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="bg-apple-gray-700 shadow-sm fixed top-0 left-0 right-0 z-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <Link to="/" className="font-bold text-xl text-white">Charly Cardeno</Link>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              id="hamburger-btn"
              aria-label={isMobileMenuOpen ? "Close navigation" : "Open navigation"}
              aria-expanded={isMobileMenuOpen}
              aria-controls="mobile-navigation"
              className="text-white hover:text-apple-gray-300 p-2"
              onClick={handleMobileMenuToggle}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                />
              </svg>
            </button>
          </div>

          {/* Desktop menu */}
          <div className="hidden lg:flex lg:items-center lg:space-x-5 text-white">
            {isHomePage ? (
              navLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="hover:text-apple-gray-300 transition-colors duration-200 font-medium"
                  onClick={() => handleNavClick(link.text.toLowerCase())}
                >
                  {link.text}
                </a>
              ))
            ) : (
              <Link
                to="/"
                className="hover:text-apple-gray-300 transition-colors duration-200 font-medium"
                onClick={() => handleNavClick('home')}
              >
                Home
              </Link>
            )}
          </div>
        </div>

        {/* Mobile menu */}
        <div id="mobile-navigation" hidden={!isMobileMenuOpen} className={`lg:hidden transition-all duration-300 ease-in-out overflow-hidden ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}>
          <div className="absolute left-0 right-0 px-6 pt-4 pb-6 space-y-2 bg-white shadow-lg">
            {isHomePage ? (
              navLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="block px-4 py-3 text-apple-gray-700 hover:text-apple-gray-900 hover:bg-apple-gray-100 rounded-lg transition-colors duration-200 font-medium"
                  onClick={() => handleNavClick(link.text.toLowerCase())}
                >
                  {link.text}
                </a>
              ))
            ) : (
              <Link
                to="/"
                className="block px-4 py-3 text-apple-gray-700 hover:text-apple-gray-900 hover:bg-apple-gray-100 rounded-lg transition-colors duration-200 font-medium"
                onClick={() => handleNavClick('home')}
              >
                Home
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
